import type { ReactNode } from 'react'

import { TIMELINE_LIST_GRID_CLASS } from './timelineGrid'
import { TimelineListSpine } from './TimelineListSpine'
import { TimelineSpineProvider } from './TimelineSpineContext'
import type { TimelineSpineSegmentStop } from './timelineSpineTypes'

export function TimelineListShell({
  roundIds,
  segmentStops,
  angular,
  children,
}: {
  roundIds: string[]
  segmentStops: TimelineSpineSegmentStop[]
  angular: boolean
  children: ReactNode
}) {
  return (
    <TimelineSpineProvider roundIds={roundIds} segmentStops={segmentStops}>
      <div className={[TIMELINE_LIST_GRID_CLASS, 'relative'].join(' ')}>
        <TimelineListSpine angular={angular} />
        {children}
      </div>
    </TimelineSpineProvider>
  )
}

/** 轮次之间的列表间距（替代 ThemeStagger gap-8） */
export function TimelineRoundGapRow() {
  return <div className="col-span-3 h-[var(--glyphicai-tl-gap,2rem)] shrink-0" aria-hidden />
}
